import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { AppAsyncThunkAPI } from '../..';
import { telemetry } from '../../../backend';
import { set } from '../../../local-storage';
import { buildMapLayerSettingsObj } from '../../../map-layer';
import { LayerConfig } from './map-settings.models';

export const updateIs3dEnabled = createAction(
  '[prepare] update is 3D enabled',
  (is3dEnabled: boolean) => ({
    payload: is3dEnabled,
  }),
);

export const resetPrepare = createAction('[prepare] reset');

export const setMapLayerConfig = createAction(
  '[map-settings] set map layer config',
  (config: LayerConfig) => ({ payload: config }),
);

export const updateSelectedMapLayers = createAsyncThunk<
  void,
  LayerConfig,
  AppAsyncThunkAPI
>(
  '[map-settings] update selected map layers',
  (selectedMapLayers, { dispatch }) => {
    telemetry(
      telemetry.DEBUG,
      `[map-settings-layer.updateSelectedMapLayers] updating selectedMapLayers to ${JSON.stringify(
        selectedMapLayers,
      )}`,
    );
    set('mapLayerService', 'selectedMapLayers', selectedMapLayers);

    dispatch(setMapLayerConfig(selectedMapLayers));
  },
);

export const switchLayer = createAsyncThunk<
  void,
  { name: string; enabled: boolean },
  AppAsyncThunkAPI
>('[map-settings] set map layer', ({ name, enabled }, { dispatch }) => {
  const layerSettings = { ...buildMapLayerSettingsObj() } as LayerConfig;
  layerSettings[name] = enabled;
  dispatch(updateSelectedMapLayers(layerSettings));
});

export const resetMapLayer = createAction('[map-settings] reset map layer');
